// CONCEPT: the Compact/Standard mode boundary, for the JS that has to agree with the
//          stylesheet about which chrome is on screen.
//
// USE:     import { COMPACT_MAX_WIDTH, compactChromeMq } from '../core/breakpoints.js';
//          if (compactChromeMq().matches) { ... }
//
// The boundary exists in three layers and each needs its own copy, because none of them
// can read the others: the `standard` mixin in src/scss/modules/_modes.scss, COMPACT_MAX
// in e2e/helpers/visual.ts, and this file. They must move together. See
// docs/responsive-layout-modes.md.
//
// WHY THIS FILE EXISTS. When the boundary moved from 576px to 768px, the markup and the
// SCSS moved and two JS width gates did not:
//
//   - autocomplete.js matched `(max-width: 575.98px)` to decide whether to open the
//     mobile results panel. Between 576 and 767 the compact search box is what renders,
//     so typing set the context to 'mobile', but the media query said desktop - and the
//     desktop panel lives inside #top-navbar, which is display:none below 768. The panel
//     opened inside a hidden subtree and the user saw no results at all.
//   - navbar.js used `< 576` to shorten the mobile placeholders.
//
// Both were invisible to the boundary guard, which only read the views and the SCSS.
// A constant plus tests/js/breakpoints.test.js is what makes the JS layer checkable.

/**
 * The last width, in CSS px, that shows the stacked compact chrome.
 *
 * 767.98 rather than 767 because this is compared against a fractional viewport width
 * in a media query - the same convention Bootstrap uses for its own max-width bounds,
 * so a 767.5px viewport is still compact.
 */
export const COMPACT_MAX_WIDTH = 767.98;

/** A MediaQueryList that matches while the compact chrome is the one on screen. */
export function compactChromeMq() {
    return window.matchMedia(`(max-width: ${COMPACT_MAX_WIDTH}px)`);
}

/** True while the compact chrome is on screen. Cheap one-shot alternative to the mq. */
export function isCompactChrome() {
    return window.innerWidth <= COMPACT_MAX_WIDTH;
}
